'use client';

import { useRef, useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { LogOut } from 'lucide-react';

export function UserMenu() {
  const { user, logout } = useAuth0();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  // Close on outside click
  useEffect(() => {
    function onPointerDown(e: PointerEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('pointerdown', onPointerDown);
    return () => document.removeEventListener('pointerdown', onPointerDown);
  }, []);

  if (!user) return null;

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex h-8 w-8 items-center justify-center overflow-hidden rounded-full border border-white/20 transition hover:border-white/40"
        aria-label="User menu"
      >
        {user.picture ? (
          <img src={user.picture} alt={user.name ?? 'User'} className="h-full w-full object-cover" />
        ) : (
          <span className="text-xs font-medium text-white">
            {(user.given_name ?? user.name ?? '?').charAt(0).toUpperCase()}
          </span>
        )}
      </button>

      {open && (
        <div className="absolute right-0 top-10 z-50 w-56 overflow-hidden rounded-xl border border-white/10 bg-zinc-900 shadow-xl">
          {/* User info */}
          <div className="border-b border-white/10 px-4 py-3">
            <p className="truncate text-sm font-medium text-white">
              {user.name ?? user.given_name ?? 'User'}
            </p>
            <p className="truncate text-xs text-white/50">{user.email}</p>
          </div>

          {/* Actions */}
          <button
            onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
            className="flex w-full items-center gap-2.5 px-4 py-3 text-sm text-white/70 transition hover:bg-white/5 hover:text-white"
          >
            <LogOut className="h-4 w-4" />
            Sign out
          </button>
        </div>
      )}
    </div>
  );
}
